import { Trans } from '@lingui/react/macro';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { useLocale } from 'hooks/useLocale';
import PdfIcon from 'svg/PdfIcon';
import styles from '../ProductItems.module.css';
import {
  FLEXI_12_ACCOUNTANTS_URL,
  FLEXI_12_BROKERS_URL,
  FLEXI_LOAN_DE_URL,
} from './productGuidesLinks';

export const FlexiLoan = () => {
  const { isDE, isUK } = useLocale();
  const { introducerType } = useIntroducerData();
  const isAccountant = introducerType === 'accountant';

  const getPDFDownloadHref = () => {
    if (isDE) {
      return FLEXI_LOAN_DE_URL;
    }
    return isAccountant ? FLEXI_12_ACCOUNTANTS_URL : FLEXI_12_BROKERS_URL;
  };

  return (
    <div className={styles.content}>
      <h2 className={styles.title}>
        {isDE ? <Trans>Flexi-Loan</Trans> : '12 months'}
      </h2>
      <p className={styles.intro}>
        <Trans>Our flexible short term loan with no fees.</Trans>
      </p>
      <ul className={styles.benefits}>
        <li className={styles.benefit}>
          {isDE ? (
            <>
              <span className={styles.benefitLabel}>
                <Trans>Borrow until</Trans>
              </span>
              <strong>
                <Trans>60 months</Trans>
              </strong>
            </>
          ) : (
            <>
              <span className={styles.benefitLabel}>Borrow over</span>
              <strong>12 months</strong>
            </>
          )}
        </li>
        <li className={styles.benefit}>
          <span className={styles.benefitLabel}>
            <Trans>Rates from</Trans>
          </span>
          <strong>{isDE ? '1%' : '2.45%'}</strong>
        </li>
        {isUK && (
          <li className={styles.benefit}>
            <span className={styles.benefitLabel}>Withdrawal fee</span>
            <strong>0%</strong>
          </li>
        )}
      </ul>
      <div className={styles.footer}>
        <PdfIcon />
        <a href={getPDFDownloadHref()} target="_blank" rel="noreferrer">
          <Trans>12 months guide</Trans>
        </a>
      </div>
    </div>
  );
};
